import styled from '@emotion/styled';
import { Input, Radio, Select } from 'antd';

export const SubTitle = styled('span')`
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  color: var(--010000-personal-area-default-profile);
  margin-bottom: 10px;
`;

export const Component = styled('div')`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
`;

export const Title = styled('div')`
  font-size: 16px;
  line-height: 19px;
  padding: 10px 0;
  border-bottom: 0.6px solid var(--E7E7E7-personal-area-default-profile);
`;

export const RadioButton = styled(Radio.Button)`
  width: 110px;
  height: 30px;
  text-align: center;
  font-size: 12px;
  line-height: 29px;
  @media screen and (max-width: 325px) {
    width: 75px;
  }
`;

export const SelectAdvanced = styled(Select)`
  width: 160px;
`;

export const EditLanguagesSpan = styled(SubTitle)`
  cursor: pointer;
  margin-left: 8px;
  color: var(--006CBA-personal-area-default-profile);
`;

export const InputText = styled(Input)`
  width: 350px;
  @media screen and (max-width: 450px) {
    width: 100%;
  }
`;

export const InputProfileName = styled('input')`
  width: 350px;
  @media screen and (max-width: 450px) {
    width: 100%;
  }

  outline: none;
  margin: 0;
  height: 32px;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 4px;
  transition: all 0.3s;
  padding: 4px 11px;

  background-color: var(--FFFFFF-antd);
  border: 1px solid var(--D9D9D9-antd);
  color: var(--000000A6-antd);
  
  :hover {
    border-color: var(--1FC47D-antd);
  }
  
  :focus {
    border-color: var(--1FC47D-antd);
    box-shadow: 0 0 0 2px var(--00B86D33-antd);
  }

  ::placeholder {
    color: var(--BFBFBF-antd);
  }
`;

export const ParamContainer = styled('div')`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

export const Row = styled('div')`
  display: flex;
  flex-direction: row;
`;

export const TooltipContainer = styled('div')`
  border-radius: 4px;
  position: absolute;
  z-index: 120;
  bottom: 8px;
  width: 250px;
  height: 32px;
  justify-content: center;
  display: flex;
  font-family: 'Roboto';
  font-style: normal;
  letter-spacing: 0.25px;
  margin-left: -125px;
`;

export const TooltipBlock = styled('div')`
  background-color: var(--FFFFFF-personal-area-default-profile);
  box-shadow: var(--box-shadow-personal-area-default-profile);
  border-radius: 4px;
  position: absolute;
  padding: 8px 12px 7px;
`;

export const TooltipInfo = styled('div')`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: var(--767676-personal-area-default-profile);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TooltipIconContainer = styled('div')`
  align-self: center;
  display: flex;
  margin-left: 8px;
  margin-top: 2px;
  font-size: 18px;
`;
